<template>
	<div>
		<div>
            <el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
                <!-- <el-form-item label="" prop="appid">
                    <app-list @getAppId="getAppId" :appId="formInline.appId" :clear="'noclear'"></app-list>
                </el-form-item> -->
                <el-form-item label="方案名称：" prop="planName">
                    <el-input v-model="formInline.planName" placeholder="请输入方案名称" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
                <br />
                <el-form-item>
                    <el-button type="success" icon="el-icon-circle-plus-outline" size="small" @click="addData">添加</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="tableTh" v-height>
            <el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle td20">
                <el-table-column prop="orderNo" label="序号" width="60">
                    <template slot-scope="scope">
                        <span>{{scope.row.orderNo}} </span>
                    </template>
                </el-table-column>
                <el-table-column label="方案名称" width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.planName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值方案（首充）">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.firstRecharge" :key="index">
                            <!-- <span>充值类型：{{item.durationType==1?'月度会员':item.durationType==2?'年度会员':item.durationType==4?'季度会员':'充值金币'}}；</span> -->
                            <span v-if="item.rechargeType == 0">充值类型：充值金币；</span>
                            <span v-if="item.rechargeType == 1">
                                充值类型：{{item.durationType==1?'月度会员':item.durationType==4?'季度会员':item.durationType==2?'年度会员':item.durationType==3?item.days + '天会员':''}}；
                            </span>
                            <span v-if="item.rechargeType == 3">充值类型：单剧购买；</span>
                            <span v-if="item.rechargeType == 3">剧名：{{item.videoName}}；</span>
                            <span>实付金额：{{item.money}}；</span>
                            <span>金币数量：{{item.rechargeType==0?(item.money * 10)*10:0}}；</span>
                            <span>充值说明：{{item.rechargeInfo}}；</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="充值方案（复充）">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.againRecharge" :key="index">
                            <!-- <span>充值类型：{{item.durationType==1?'月度会员':item.durationType==2?'年度会员':item.durationType==4?'季度会员':'充值金币'}}；</span> -->
                            <span v-if="item.rechargeType == 0">充值类型：充值金币；</span>
                            <span v-if="item.rechargeType == 1">
                                充值类型：{{item.durationType==1?'月度会员':item.durationType==4?'季度会员':item.durationType==2?'年度会员':item.durationType==3?item.days + '天会员':''}}；
                            </span>
                            <span v-if="item.rechargeType == 3">充值类型：单剧购买；</span>
                            <span v-if="item.rechargeType == 3">剧名：{{item.videoName}}；</span>
                            <span>实付金额：{{item.money}}；</span>
                            <span>金币数量：{{item.rechargeType==0?(item.money * 10)*10:0}}；</span>
                            <span>充值说明：{{item.rechargeInfo}}；</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="小程序" width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.appName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="350">
                    <template slot-scope="scope" class="ddd">
                        <el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row.id)">详情</el-button>
                        <el-button type="defult" icon="el-icon-setting" size="mini" @click="handleConfig(scope.row.id)">配置</el-button>
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
                        
                        <!-- <el-popover v-has="'rechargeConfig:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">
                            <p class="popover-con del">
                                <i class="el-icon-question warnning-text"></i>确定删除吗？
                            </p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
                                <el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
                            </div>
                            <el-button slot="reference" type="danger" :disabled="scope.row.isShow == 1 ? true : false" icon="el-icon-delete" size="mini">删除</el-button>
                        </el-popover> -->
                        <!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>

            <div class="foot-table" style="text-align:center;">
                <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :page-sizes="[20, 50, 100, 200, 500]"
                    :page-size="tableData.pageSize"
                    background
                    :current-page="currentPage"
                    layout="sizes, prev, pager, next, jumper, ->, total"
                    :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="dialogWayInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td width="200">方案名称</td>
						<td>
							<span>{{ ruleForm.planName }}</span>
						</td>
					</tr>
					<tr>
						<td width="200">充值方案（首充）</td>
						<td>
							<p v-for="(item,index) in ruleForm.firstRecharge" :key="index">
								<!-- <span>充值类型：{{item.durationType==1?'月度会员':item.durationType==2?'年度会员':item.durationType==4?'季度会员':'充值金币'}}；</span> -->
                                <span v-if="item.rechargeType == 0">充值类型：充值金币；</span>
                                <span v-if="item.rechargeType == 1">
                                    充值类型：{{item.durationType==1?'月度会员':item.durationType==4?'季度会员':item.durationType==2?'年度会员':item.durationType==3?item.days + '天会员':''}}；
                                </span>
                                <span v-if="item.rechargeType == 3">充值类型：单剧购买；</span>
                                <span v-if="item.rechargeType == 3">剧名：{{item.videoName}}；</span>
                                <span>实付金额：{{item.money}}；</span>
								<span>金币数量：{{item.rechargeType==0?(item.money * 10)*10:0}}；</span>
								<span>充值说明：{{item.rechargeInfo}}；</span>
							</p>
						</td>
					</tr>
					<tr>
						<td width="200">充值方案（复充）</td>
						<td>
							<p v-for="(item,index) in ruleForm.againRecharge" :key="index">
								<!-- <span>充值类型：{{item.durationType==1?'月度会员':item.durationType==2?'年度会员':item.durationType==4?'季度会员':'充值金币'}}；</span> -->
                                <span v-if="item.rechargeType == 0">充值类型：充值金币；</span>
                                <span v-if="item.rechargeType == 1">
                                    充值类型：{{item.durationType==1?'月度会员':item.durationType==4?'季度会员':item.durationType==2?'年度会员':item.durationType==3?item.days + '天会员':''}}；
                                </span>
                                <span v-if="item.rechargeType == 3">充值类型：单剧购买；</span>
                                <span v-if="item.rechargeType == 3">剧名：{{item.videoName}}；</span>
                                <span>实付金额：{{item.money}}；</span>
								<span>金币数量：{{item.rechargeType==0?(item.money * 10)*10:0}}；</span>
								<span>充值说明：{{item.rechargeInfo}}；</span>
							</p>
						</td>
					</tr>
					<tr>
						<td>小程序</td>
						<td>
							<p>{{ ruleForm.appName }}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogWayInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
        <!--编辑弹框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="600px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350" style="max-height: 480px;overflow: auto; padding-right: 20px;">
				<el-form-item label="方案名称：" prop="planName">
					<el-input v-model="ruleForm.planName" placeholder="请输入方案名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="排序：" prop="orderNo">
					<el-input type="number" v-model="ruleForm.orderNo" placeholder="请输入排序" clearable></el-input>
				</el-form-item>
				<el-form-item label="小程序" prop="appName">
                    <el-input  v-model="ruleForm.appName" disabled placeholder="请输入小程序" clearable></el-input>
					<!-- <app-list @getAppId="getConfigAppId" :appId="ruleForm.appId" :clear="'noclear'" style="width: 90%;"></app-list> -->
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
        </el-dialog>
        <!--充值方案配置-->
		<el-dialog :dialogTitle="dialogTitle" :visible.sync="dialogConfigVisible" width="800px">
			<div style="position: relative;">
				<el-form>
					<el-form-item label="" prop="firstRecharge">
						<div style="display: flex;">
							<p>充值方案（首充）：</p>
							<el-button type="primary" size="mini" style="height: 30px;margin: 6px 0 16px 10px" @click="addGear(1,ruleForm.firstRecharge)">添加</el-button>
						</div>
						<el-table :data="ruleForm.firstRecharge" border stripe style="width: 800px;" >
							<el-table-column label="充值类型" width="150">
								<template slot-scope="scope">
									<!-- <span v-if="scope.row.durationType==0">充值金币</span>
									<span v-if="scope.row.durationType==1">月度会员</span>
									<span v-if="scope.row.durationType==2">年度会员</span>
									<span v-if="scope.row.durationType==4">季度会员</span> -->
                                    <span v-if="scope.row.rechargeType == 0">充值金币</span>
                                    <span v-if="scope.row.rechargeType == 1">
                                        {{scope.row.durationType==1?'月度会员':scope.row.durationType==4?'季度会员':scope.row.durationType==2?'年度会员':scope.row.durationType==3?scope.row.days + '天会员':''}}
                                    </span>
                                    <span v-if="scope.row.rechargeType == 3">单剧购买</span>
								</template>
							</el-table-column>
							<el-table-column label="充值金额"  width="150">
								<template slot-scope="scope">
									<p>实付金额：{{ scope.row.money }}</p>
									<p>划线价：{{ scope.row.originalPrice }}</p>
                                    <p v-if="scope.row.rechargeType == 3">剧名：{{scope.row.videoName}}；</p>
								</template>
							</el-table-column>
							<el-table-column label="其他信息" >
								<template slot-scope="scope">
									<p>金币数量：{{scope.row.rechargeType == 0?((scope.row.money || 0) * 10)*10 + (scope.row.present || 0) : 0 }}</p>
									<p>充值说明：{{ scope.row.rechargeInfo }}</p>
									<p>档位描述：{{ scope.row.templateInfo }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="orderNo" label="序号" width="80" >
								<template slot-scope="scope">
                                    <div class="change-no">
                                        <span>{{scope.row.orderNo}} </span>
                                        <div class="change-no-icon">
                                            <i class="el-icon-caret-top" @click="FirChangeOrderNo('up',scope.$index)"></i>
                                            <i class="el-icon-caret-bottom" @click="FirChangeOrderNo('down',scope.$index)"></i>
                                        </div>
                                    </div>
									
								</template>
							</el-table-column>
							<el-table-column label="操作" width="80">
								<template slot-scope="scope" class="ddd">
									<el-popover width="150" :ref="scope.row.id" style="margin-left: 10px;">
										<p class="popover-con del">
											<i class="el-icon-question warnning-text"></i>确定删除吗？
										</p>
										<div style="text-align: right; margin: 0">
											<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
											<el-button type="primary" size="mini" @click="delGear(scope.row.id)">确定</el-button>
										</div>
										<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"></el-button>
									</el-popover>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
					<el-form-item label="" prop="againRecharge">
						<div style="display: flex;">
							<p>充值方案（复充）：</p>
							<el-button type="primary" size="mini" style="height: 30px;margin: 6px 0 16px 10px" @click="addGear(0,ruleForm.againRecharge)">添加</el-button>
						</div>
						<el-table :data="ruleForm.againRecharge" border stripe style="width: 100%;">
							<el-table-column label="充值类型"  width="150">
								<template slot-scope="scope">
                                    <span v-if="scope.row.rechargeType == 0">充值金币</span>
                                    <span v-if="scope.row.rechargeType == 1">
                                        {{scope.row.durationType==1?'月度会员':scope.row.durationType==4?'季度会员':scope.row.durationType==2?'年度会员':scope.row.durationType==3?scope.row.days + '天会员':''}}
                                    </span>
                                    <span v-if="scope.row.rechargeType == 3">单剧购买</span>
								</template>
							</el-table-column>
							<el-table-column label="充值金额" width="150" >
								<template slot-scope="scope">
									<p>实付金额：{{ scope.row.money }}</p>
									<p>划线价：{{ scope.row.originalPrice }}</p>
                                    <p v-if="scope.row.rechargeType == 3">剧名：{{scope.row.videoName}}；</p>
								</template>
							</el-table-column>
							<el-table-column label="其他信息" >
								<template slot-scope="scope">
									<p>金币数量：{{ scope.row.rechargeType == 0?((scope.row.money || 0) * 10)*10 + (scope.row.present || 0) : 0 }}</p>
									<p>充值说明：{{ scope.row.rechargeInfo }}</p>
									<p>档位描述：{{ scope.row.templateInfo }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="orderNo" label="序号" width="80" >
								<template slot-scope="scope">
                                    <div class="change-no">
                                        <span>{{scope.row.orderNo}} </span>
                                        <div class="change-no-icon">
                                            <i class="el-icon-caret-top"  @click="agChangeOrderNo('up',scope.$index)"></i>
                                            <i class="el-icon-caret-bottom"  @click="agChangeOrderNo('down',scope.$index)"></i>
                                        </div>
                                    </div>
									<!-- <span>{{scope.row.orderNo}} </span> -->
								</template>
							</el-table-column>
							<el-table-column label="操作" width="80">
								<template slot-scope="scope" class="ddd">
									<el-popover width="150" :ref="scope.row.id" style="margin-left: 10px;">
										<p class="popover-con del">
											<i class="el-icon-question warnning-text"></i>确定删除吗？
										</p>
										<div style="text-align: right; margin: 0">
											<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
											<el-button type="primary" size="mini" @click="delGear(scope.row.id)">确定</el-button>
										</div>
										<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"></el-button>
									</el-popover>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogConfigVisible = false">关 闭</el-button>
				<!-- <el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button> -->
			</div>
		</el-dialog>
        <recharge-table-more :visible.sync="isShowDialogVideo" :selectList="selectList" :appId="formInline.appId" @gearSure="gearSure" @cancelDialogVideo="cancelDialogVideo"></recharge-table-more>
	</div>
</template>
<script>
// import AppList from '@/components/AppList'
import RechargeTableMore from '@/components/RechargeTableMore'
// 
import {planList, planDetails, planAdd, planAddGear, planDelGear, planOrder} from "@/api/dysvzk/agentmenu/recharge";
export default {
    name:'AgentRechargePlan',
    components: {
        // AppList,
        RechargeTableMore
    },
    data() {
        return {
            formInline: {
				appId: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
                planName:'',
                appName:JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName
			},
            currentPage: 1,
            tableData: {
                pageSize: 20,
                pageNo: 1,
                totalPage: 1,
                totalNum: 0,
                result: []
            },
            ruleForm:{
                appId:'',
                appName:'',
                id:'',
                orderNo:'',
                planName:'',
                updateType:'',
                firstRecharge:[],
                againRecharge:[]
            },
            dialogFormVisible:false,
            dialogWayInfoVisible:false,
            dialogTitle:'',
            rules:{
                planName: [
					{required: true, message: '请输入方案名称', trigger: 'change'},
				],
                appId: [
					{required: true, message: '请选择小程序', trigger: 'change'},
				],
                orderNo: [
					{required: true, message: '请输入序号', trigger: 'change'},
				],
            },
            planId:null,
            dialogConfigVisible:false,
            isShowDialogVideo:false,
            selectVideo: {},
            dataIds: '', //档位id
			isFirstRecharge:1,
            selectList:[]
        }
    },
    computed: {},
    watch: {},
    mounted: function() {
        this.getTableData()
    },
    methods: {
        search () {
			this.currentPage = 1
			this.getTableData()
		},
        // 从组件获取appid
		// getAppId(data) {
		// 	this.formInline.appId = data
		// 	this.getTableData()
		// },
        // 充值方案配置小程序
		// getConfigAppId(data) {
		// 	this.formInline.appName = JSON.parse(localStorage.getItem('appList')).filter(item => item.appId === data)
		// 	this.formInline.appId = data
		// 	// this.getTableData(this.tabValue)
		// },
        handleCurrentChange(value) {
            this.currentPage = value
            this.getTableData()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.tableData.pageSize  = val
            this.currentPage = 1
            this.getTableData()
        },
        //获取列表
        getTableData() {
            let json2 = {
                pageNo: this.currentPage,
                pageSize: this.tableData.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            console.log("paramJson",paramJson)
            planList(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        addData(){
            console.log("添加")
            if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
            this.dialogFormVisible = true
            this.dialogTitle = '添加充值方案配置'
            // const appName = JSON.parse(localStorage.getItem('appList')).filter(item => item.appId === this.formInline.appId)[0].name
            this.ruleForm = {
                appId:this.formInline.appId,
                appName:this.formInline.appName,
                id:'',
                orderNo:'',
                planName:'',
                updateType: "add",
                firstRecharge:[],
                againRecharge:[],
            }
            // this.selectVideo= {}
            // this.dataIds= ''
        },
        //确定保存
        editDialogSureBtn(formName){
            this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveTableData('add')
				} else {
					console.log('error submit!!');
					return false;
				}
			});
        },
        // 保存编辑信息
		saveTableData () {
			console.log(this.ruleForm)
            // let json3 = {
            //     appId: this.formInline.appId
            // };
            // let json4 = this.ruleForm;
            // let paramJson1 = { ...json3, ...json4 }
            const info = {
                appId:this.formInline.appId || '',
                id:this.ruleForm.id || '',
                planName:this.ruleForm.planName || '',
                orderNo:this.ruleForm.orderNo || ''
            }
            planAdd(info).then(response => {
                if (response.data.head.flag === 0) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.getTableData()
                    this.dialogFormVisible = false
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
			
		},
        //详情
        handleLook(id) {
			this.dialogWayInfoVisible = true
            this.getDetails(id)
		},
        //获取详情
        getDetails(id){
            planDetails({
				id: id
			}).then(response => {
                if (response.data.head.flag === 0) {
                    this.ruleForm = response.data.content
					this.ruleForm.change = 'upd'
                    this.ruleForm.updateType = 'edit'
                } else {
                    this.$message.error(response.data.head.desc)
                }
            }); 
        },
        // 编辑
		handleEdit(id) {
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
            this.dialogTitle = '编辑充值方案配置'
            this.dialogFormVisible = true
            this.getDetails(id)
		},
        //配置
        handleConfig(id){
            this.dialogTitle = '充值方案配置'
			this.dialogConfigVisible = true
			this.planId = id;
			this.getDetails(id)
        },
        //添加充值档位
		addGear(val,list){
			this.isShowDialogVideo = true
			this.isFirstRecharge = val;
            this.selectList = list;
		},
        //确定选择档位
        gearSure(data) {
            console.log(data)
            this.dataIds = data.videoListStr
            this.selectVideo = data
            planAddGear({
                templateIds: this.dataIds,
                planId: this.planId,
				isFirstRecharge:this.isFirstRecharge
			}).then(response => {
                if (response.data.head.flag === 0) {
                    // this.getTableDataVideo()
					this.getTableData()
					this.getDetails(this.planId)
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        // 关闭充值档位弹窗
        cancelDialogVideo(data) {
            this.isShowDialogVideo = data
        },
        //删除已配置的档位
		delGear(id){
			planDelGear({
                id: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.$refs[id].doClose()
                    this.getTableData()
					this.getDetails(this.planId)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
		},

        onPlanOrder(list){
            list.forEach((element,index) => {
                planOrder({
                    id: element.id,
                    orderNo:index + 1
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        this.getTableData()
                        this.getDetails(this.planId)
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })   
            });
           
        },   
        //改变配置方案的档位顺序(首充)
        FirChangeOrderNo(type,index){
            if(type == 'up'){//上移
                if(index == 0){
                    this.$message.warning('已在第一位,不能上移');
                    return ;
                }
                const upDate = this.ruleForm.firstRecharge[index - 1];
                this.ruleForm.firstRecharge.splice(index - 1, 1);
                this.ruleForm.firstRecharge.splice(index, 0, upDate);
                this.onPlanOrder(this.ruleForm.firstRecharge)

            }else{//下移
                if(index == this.ruleForm.firstRecharge.length - 1){
                    this.$message.warning('已经是最后一条，不可下移');
                    return ;
                }
                const downDate = this.ruleForm.firstRecharge[index + 1];
                this.ruleForm.firstRecharge.splice(index + 1, 1);
                this.ruleForm.firstRecharge.splice(index, 0, downDate);
                this.onPlanOrder(this.ruleForm.firstRecharge)
            }   
        },
        //改变配置方案的档位顺序(复充)
        agChangeOrderNo(type,index){
            if(type == 'up'){//上移
                if(index == 0){
                    this.$message.warning('已在第一位,不能上移');
                    return ;
                }
                const upDate = this.ruleForm.againRecharge[index - 1];
                this.ruleForm.againRecharge.splice(index - 1, 1);
                this.ruleForm.againRecharge.splice(index, 0, upDate);
                this.onPlanOrder(this.ruleForm.againRecharge)

            }else{//下移
                if(index == this.ruleForm.againRecharge.length - 1){
                    this.$message.warning('已经是最后一条，不可下移');
                    return ;
                }
                const downDate = this.ruleForm.againRecharge[index + 1];
                this.ruleForm.againRecharge.splice(index + 1, 1);
                this.ruleForm.againRecharge.splice(index, 0, downDate);
                this.onPlanOrder(this.ruleForm.againRecharge)
            }   
        }
    }
}
</script>
<style lang="scss">
    .tableTh{
        margin-top: 16px;
    }
    .change-no{
        display: flex;
        align-items: center;
        justify-content: space-around;
        width:60px;
        height: 40px;
        border: 1px solid #c5c5c5;
        border-radius: 6px;
        .change-no-icon{
            display: flex;
            flex-direction: column;
            cursor: pointer;
            .el-icon-caret-top:hover,.el-icon-caret-bottom:hover{
                color: #5cb6ff;
            }
        }
    }
</style>
